import { t } from '@lingui/macro';

export const SERVER_SYSLOG_SEVERITY = 'serverSeverity';
export const DEVICE_SYSLOG_SEVERITY = 'deviceSeverity';
export const SEVERITY_TO_STRING_MAPPING = {
    0: t`Emergency`,
    1: t`Emergency To Alert`,
    2: t`Emergency To Critical`,
    3: t`Emergency To Error`,
    4: t`Emergency To Warning`,
    5: t`Emergency To Notice`,
    6: t`Emergency To Informational`,
    7: t`Emergency To Debug`,
};
